<template>
  <div class="text-center py-1 lg:px-1 w-full">
    <div class="p-2 bg-yellow-800 items-center text-yellow-100 leading-none lg:rounded-full flex lg:inline-flex w-full"
      role="alert">
      <span class="flex rounded-full bg-yellow-900 uppercase px-2 py-1 text-md font-bold mr-3">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
      </span>
      <span class="mr-2 text-left text-xs flex-auto">{{
        $t('INBOX_MGMT.SETTINGS_POPUP.ALERT_SYNC_TEMPLATES')
        }}</span>
    </div>
  </div>
  <div class="flex flex-col gap-2">
    <div class="flex items-center gap-2">
      <h1 class="text-xl font-bold text-n-slate-12">
        Connect WhatsApp Business Platform (API)
      </h1>
    </div>
  </div>
  <div class="flex flex-col gap-2">
    <!--<div v-for="category in categories" :key="category.key" class="flex items-center gap-2">
      <RadioButton v-model="selectedCategory" :inputId="category.key" name="dynamic" :value="category.key" />
      <div class="flex flex-col gap-2">
        <h1 class="text-md font-bold text-gray-800">
          {{ category.name }}
        </h1>
        <p class="text-xs text-gray-600">
          {{ category.explanation }}
        </p>
      </div>
    </div>-->
    <Divider type="solid" />
    <div class="flex flex-col gap-4">
      <div class="text-sm text-n-slate-9 flex items-center gap-2">
        <!--<NextButton class="ml-2" icon="i-lucide-arrow-right" label="Siguiente" @click="go" />-->
        <FacebookLogin @onLogin="handleLogin" :label="`Login session with Facebook`" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, defineEmits, computed } from 'vue';
import { useRouter } from 'vue-router';
import NextButton from 'dashboard/components-next/button/Button.vue';
import FacebookLogin from '../FacebookLogin.vue';
const router = useRouter();
const emit = defineEmits(['change-step', 'on-login']);
const accessToken = ref(null);
const selectedCategory = ref('A');
const categories = ref([
  {
    name: 'Create and connect a new Whatsapp Business Platform (API) account',
    explanation:
      'Select this option if you want to create and connect a new WhatsApp Business Platform (API) account and connect it to your WhatsApp Business account.',
    key: 'A',
  },
  {
    name: 'Connect an existing Whatsapp Business Platform (API) account',
    explanation:
      'Select this option if you have created a Whatsapp Business Platform (API) account before',
    key: 'M',
  },
]);

function handleLogin({ accessToken: token, userID: userID }) {
  accessToken.value = token;
  emit('on-login', {token: accessToken.value, userID: userID});
  emit('change-step', 'skip_login');
}

const go = () => {
  console.log('selectedCategory.value', selectedCategory.value);
  if (selectedCategory.value == 'A') {
    emit('change-step', 'new_connection');
  } else if (selectedCategory.value == 'M') {
    emit('change-step', 'existing_connection');
  }
};
</script>